import React, { Component } from 'react';

class DonationFailure extends Component {
  render() {
    let errorBox;
    let errorCode = '';
    if (typeof this.props.error === "object" && 'dtoRes' in this.props.error) errorCode = this.props.error.dtoRes.dtoError.errorCode;
    if (errorCode === '3103') {
      errorBox = 'Il Tinabalike non è andato a buon fine. Hai raggiunto il limite massimo giornaliero di Tinabalike';
    } else {
      errorBox = 'Il Tinabalike non è andato a buon fine.';
    }
    return (
      <main className="app-body">
        <div className="message-box">
          <h3>{errorBox}</h3>
          <svg width="60px" height="60px" viewBox="0 0 60 60" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>TinabaLike/KO</title>
            <desc>Created with Sketch.</desc>
            <defs></defs>
            <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="TinabaLike/KO" fill="#D0021B">
                <rect id="Rectangle-17" transform="translate(29.656854, 29.606602) rotate(-45.000000) translate(-29.656854, -29.606602) " x="16.6568542" y="27.6066017" width="26" height="4"></rect>
                <rect id="Rectangle-17" transform="translate(29.656854, 29.606602) rotate(-315.000000) translate(-29.656854, -29.606602) " x="16.6568542" y="27.6066017" width="26" height="4"></rect>
                <path d="M30,56 C15.6405965,56 4,44.3594035 4,30 C4,15.6405965 15.6405965,4 30,4 C44.3594035,4 56,15.6405965 56,30 C56,44.3594035 44.3594035,56 30,56 Z M30,52 C42.1502645,52 52,42.1502645 52,30 C52,17.8497355 42.1502645,8 30,8 C17.8497355,8 8,17.8497355 8,30 C8,42.1502645 17.8497355,52 30,52 Z" id="Combined-Shape"></path>
              </g>
            </g>
          </svg>
        </div>
      </main>
    );
  }
}

export default DonationFailure;



/** WEBPACK FOOTER **
 ** ./src/components/DonationFailure.jsx
 **/